const scope_0 = require('/codebuild/output/src624843067/src/lenny-s.com/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default {
  ...scope_0
}